<template>
  <div class="appdetail" v-loading="loadingObj.loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">
    <!-- 标题、按钮 -->
    <div class="appdetail-title" :style="{ height: '40px'}">
      <div class="appdetail-title-top clearfix">
        <!-- <div class="app-titles" v-if="!!currentMainTableJson.columns">
                    <i :class="currentSelectMenuData.css" class="app-title-icon"></i>
                    <span class="app-title-main">{{currentMainTableJson.columns[0].name}}&nbsp;{{detailInfos[currentMainTableJson.columns[0].model]}}</span>
                </div> -->
        <!-- <div class="app-titles app-titles1 ml10">
                    <i v-if="!!detailInfos.createuserdesc" class="el-icon-time ml5"></i>
                    <span v-if="!!detailInfos.createuserdesc" class="ml5">{{detailInfos.createuserdesc}}</span>
                    <span class="ml5">创建于</span>
                    <span v-if="!!detailInfos.createtime" class="ml5" style="color: #08979c">{{$moment(detailInfos.createtime).fromNow()}}</span>
                    <i v-if="!!detailInfos.updateuserdesc" class="el-icon-time ml10"></i>
                    <span v-if="!!detailInfos.updateuserdesc" class="ml5">{{detailInfos.updateuserdesc}}</span>
                    <span class="ml5">更新于</span>
                    <span v-if="!!detailInfos.updatetime" class="ml5" style="color: #08979c">{{$moment(detailInfos.updatetime).fromNow()}}</span>
                </div> -->
        <div class="app-buttons">
          <!-- 正常按钮 -->
          <template v-for="item in detailButtons">
            <el-button v-if="item.eventmethod == 'saveBtn'" :icon="item.icon" :class="'btn '+ item.style" :key="item.id" size="mini" @click="btnClick(item)">
              <font>{{item.name}}</font>
            </el-button>
            <el-button v-if="item.eventmethod != 'saveBtn' && !!detailInfos.id" :icon="item.icon" :class="'btn '+ item.style" :key="item.id" size="mini" @click="btnClick(item)">
              <font>{{item.name}}</font>
            </el-button>
          </template>
          <!-- 流程按钮 -->
          <template v-if="currentAppIsHasFlow && isHasFlowBtn && isApprove == 0">
            <el-button class="btn btn-green" size="mini" @click="startUp">
              <font>提交审批</font>
            </el-button>
          </template>
          <template v-if="currentAppIsHasFlow && isHasFlowBtn && isApprove == 1">
            <el-button class="btn btn-green" size="mini" @click="approval">
              <font>提交</font>
            </el-button>
          </template>
          <template v-if="currentAppIsHasFlow && isHasFlowBtn && isShowtransfer">
            <el-button class="btn btn-green" size="mini" @click="transfer">
              <font>转办</font>
            </el-button>
          </template>
          <!-- 流程地图 -->
          <template v-if="currentAppIsHasFlow && isHasFlowBtn">
            <el-button class="btn btn-green" size="mini" @click="getFlowMap">
              <font>流程地图</font>
            </el-button>
          </template>
          <!-- 流程历史 -->
          <template v-if="currentAppIsHasFlow && isHasFlowBtn">
            <el-button class="btn btn-green" size="mini" @click="getflowHistory">
              <font>流程历史</font>
            </el-button>
          </template>
          <!-- 流程历史 -->
          <template v-if="currentAppIsHasFlow && isHasFlowBtn">
            <el-button class="btn btn-green" size="mini" @click="getViewPople">
              <font>当前责任人</font>
            </el-button>
          </template>
          <!-- <template>
                        <el-button v-if="pageSign == 'view' && !isCanEditDetailInfo && isShowEditBtn" class="btn btn-green" size="mini" @click="editBtn">
                            <font>编辑</font>
                        </el-button>
                    </template> -->
        </div>
      </div>
    </div>
    <!-- 解析详情页面 -->
    <div v-if="!!jsonData && !!jsonData.config" class="appdetail-content" :style="{height: 'calc(100vh - 128px)', transition: 'all 0.3s ease-in 0s'}">
      <el-form ref="form" :model="detailInfos" :size="jsonData.config.size" :label-position="jsonData.config.labelPosition" :label-width="jsonData.config.labelWidth + 'px'" :class="jsonData.config.customClass" class="demo-user">
        <detailsPageTabs :istodoPage="!!bizId ? false : true" ref="parseDetailsPage" :pageHeight="'calc(100vh - 200px)'"></detailsPageTabs>
      </el-form>
    </div>
    <!-- 流程地图 -->
    <div class="popupBox" v-if="isShowFlowMap">
      <div class="popupBox-content">
        <div class="popupBox-content-header">
          <span class="popupBox-content-header-title">流程地图</span>
          <span class="popupBox-content-header-close"><i class="el-icon-close" @click="isShowFlowMap = false"></i></span>
        </div>
        <div class="popupBox-content-body" v-loading="flowmaploading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">
          <div class="flowMapBox">
            <img :src="flowMapSrc" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- 流程审批 -- 审批意见 -->
    <el-dialog :modal-append-to-body="true" title="审批" :append-to-body="true" :visible.sync="innerVisible" width="50%">
      <el-form ref="approveForm" :model="approveForm" label-width="120px" class="demo-ruleForm">
        <el-row :gutter="30">
          <el-col :span="23">
            <el-form-item label="审批意见" prop="opinion">
              <el-input type="textarea" :autosize="{ minRows:5}" placeholder="请输入内容" v-model="approveForm.opinion"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button size="mini" :type="(item.direction == '1' ? 'success ' : (item.direction == '0' ? 'danger' : 'warning '))" v-for="(item,idx) in approvebtnList" :key="idx" @click="approveBtns(item)">{{item.name}}</el-button>
      </div>
    </el-dialog>
    <!-- 流程历史 -->
    <el-dialog :modal-append-to-body="true" :append-to-body="true" title="流程历史" :visible.sync="flowhistorydialog" width="20%">
      <el-steps direction="vertical" :space="150" :active="3" finish-status="success">
        <el-step :title="item.nodeName" :status="item.flag" :key="item.id" v-for="item in flowHistoryList" :id="item.id">
          <template slot="description">
            <div v-if="item.nodeId != 'end'" class="flowHistory-person">审批人：<span style="color: #08979c">{{item.opName}}</span></div>
            <div v-if="item.nodeId != 'end'" class="flowHistory-time">{{item.createTime}}</div>
            <div v-if="item.nodeId != 'end'" class="flowHistory-opinion">{{item.opinion}}</div>
            <div v-if="item.nodeId == 'end'">流程已结束</div>
          </template>
        </el-step>
      </el-steps>
    </el-dialog>
    <!-- 当前责任人 -->
    <el-dialog :modal-append-to-body="true" :append-to-body="true" title="当前责任人" :visible.sync="flowpeopledialog" width="30%">
      <el-input type="textarea" disabled :rows="2" v-model="flowuser"></el-input>
    </el-dialog>
    <!-- 客户化组件 -->
    <customizationComponents ref="customizationComponents"></customizationComponents>
    <vchoose ref="choose" :chooseParam="chooseParam" @returnSelectValue="updateChoose"></vchoose>
  </div>
</template>

<script>
import vchoose from '@/components/commonComponents/datachoose.vue'
import detailsPageTabs from "./detailsPageTabs"
import customizationComponents from "@/page/zhonglv/zhonglv.vue"  //客户化处理组件
export default {
  name: 'detailPages',
  components: { detailsPageTabs, customizationComponents , vchoose},
  data() {
    return {
      basic_url: Config.dev_url,//请求地址
      loadingObj: {
        loading: false, //详情页加载loading
      },
      listItem: {}, //选中列表当前数据
      flowHistoryList: [], //流程历史
      flowuser: "",//当前责任人
      flowusername: "",
      isShowFlowMap: false, //是否显示流程地图
      flowMapSrc: "",  //流程地图图片
      flowloading: false, //流程历史加载loading
      flowmaploading: false, //流程地图加载loading
      isApprove: 3, //提交审批 / 审批按钮显示状态
      pageSign: '',
      innerVisible: false,
      approveForm: {
        opinion: '',
      },
      rules: {
        opinion: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 2, max: 255, message: '长度在 2 到 255 个字符', trigger: 'blur' }
        ],
      },
      approvebtnList: [],
      isShowEditBtn: true,
      flowhistorydialog: false,//流程历史弹框
      flowpeopledialog: false, //当前责任人弹框
      validateChildFormResult: [],//子表必填验证结果
      bizId: "",//待办任务的id
      chooseParam:{},
      isShowtransfer:false,
    }
  },
  methods: {
    updateChoose(data){
        var url = Config.dev_url + "/api-flow/flow/provider/flowAssigneeToUser?app=" + this.$route.params.app + "&id=" + this.detailInfos.id + "&tousername=" + data.username
        this.$axios.get(url).then((res)=>{
            console.log(res)
            if(res.data.code==0){
                this.$message.success(res.data.msg)
            }else{
                this.$message.warning(res.data.msg == null ? res.data.data : res.data.msg )
            }
        })

    },
    transfer(){
        var chooseParam = {
        title: "人员",
        searchBtn: true,
        isMulti:false,
        customWidth:"70%",
        tableHeader: [
          {
            propName: "username",
            labelName: "用户名",
            isSearch: 'yes',
            isShow: 'yes',
            width: '35%',
          },
          {
            propName: "nickname",
            labelName: "姓名",
            isSearch: 'yes',
            isShow: 'yes',
            width: '35%',
          },
          {
            propName: "deptName",
            labelName: "机构",
            isSearch: 'no',
            isShow: 'yes',
            width: '35%',
          },
        ],
        search: [],
        url: "/api-user/users",
        method: "get"
      };
      this.chooseParam = chooseParam;
      this.$refs.choose.getListData("new", this.chooseParam);
    },
    //主表按钮点击
    btnClick(item) {
      if (!!this[item.eventmethod]) {
        this[item.eventmethod](item)
      } else {
        this.$refs.customizationComponents.detailTableButtons(item)
      }
    },
    //判断当前单据是否已经启动流程
    isWhichNode() {
      var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/NodeId/' + this.detailInfos.id;
      this.$axios.get(url, {}).then((res) => {
        if (res.data.code == 1) {
          this.isApprove = 0;
        } else {
          this.isApprove = 1;
        }
      }).catch((err) => {
      });
    },
    //报表按钮点击
    reportBtn(item) {
      let routeData = this.$router.resolve({
        path: "/customreportchart",
        query: {
          appname: this.$route.params.app,
          id: this.detailInfos.id,
          roleCode: this.currentuser.rolecode
        }
      });
      window.open(routeData.href, "_blank");
    },
    //编辑按钮点击
    editBtn() {
      this.$store.commit('setisCanEditDetailInfo', true)
    },
    //进入详情时对详情数据进行一些特殊处理
    initDetailData(data) {
      for (let key in data) {
        if (key.indexOf('.') !== -1) {     //对  一对一主子表字段的特殊处理
          data[key.replace('.', '-')] = data[key]
        } else {
          data[key] = data[key]
        }
      }
      this.detailJosnArr.forEach((detailJosnArrItem) => {
        if (detailJosnArrItem.type == 'checkbox') {
          if (!!data[detailJosnArrItem.model]) {
            this.$set(data, detailJosnArrItem.model + 'CheckboxModel', data[detailJosnArrItem.model].split(","))
          } else {
            this.$set(data, detailJosnArrItem.model + 'CheckboxModel', [])
          }
        } else if (detailJosnArrItem.type == 'select' && detailJosnArrItem.options.multiple) {
          if (!!data[detailJosnArrItem.model]) {
            this.$set(data, detailJosnArrItem.model + 'SelectBox', data[detailJosnArrItem.model].split(","))
          } else {
            this.$set(data, detailJosnArrItem.model + 'SelectBox', [])
          }
        }
      })
    },
    //新建默认值的处理
    initAddDefault(obj) {
      for (var i = 0; i < this.detailJosnArr.length; i++) {
        if (this.detailJosnArr[i].model.indexOf('.') !== -1) {     //对  一对一主子表字段的特殊处理
          obj[this.detailJosnArr[i].model.replace('.', '-')] = ''
        } else {
          if (!!this.detailJosnArr[i].options.defaultValue) {
            if (this.detailJosnArr[i].type == 'number') {
              obj[this.detailJosnArr[i].model] = Number(this.detailJosnArr[i].options.defaultValue)
            } else if (this.detailJosnArr[i].type == 'switch') {
              obj[this.detailJosnArr[i].model] = '0'
            } else if (this.detailJosnArr[i].options.defaultValue.indexOf('currentuser:') !== -1) {
              if (this.detailJosnArr[i].options.defaultValue.indexOf('createtime') !== -1) {
                obj[this.detailJosnArr[i].model] = this.$moment().format("YYYY-MM-DD HH:mm:ss")
              } else {
                obj[this.detailJosnArr[i].model] = this.currentuser[this.detailJosnArr[i].options.defaultValue.substr(this.detailJosnArr[i].options.defaultValue.indexOf('currentuser:') + 12, this.detailJosnArr[i].options.defaultValue.length)]
              }
            } else {
              obj[this.detailJosnArr[i].model] = (this.detailJosnArr[i].options.defaultValue).toString()
            }
          } else {
            obj[this.detailJosnArr[i].model] = "";
          }
          if (this.detailJosnArr[i].type == 'checkbox') {
            obj[this.detailJosnArr[i].model + 'CheckboxModel'] = []
          } else if (this.detailJosnArr[i].type == 'select' && this.detailJosnArr[i].options.multiple) {
            obj[this.detailJosnArr[i].model + 'SelectBox'] = []
          }
        }
      }
    },
    //提交审批前的判断
    startUp() {
      if (this.isCanEditDetailInfo) {
        this.$confirm("提交审批会自动保存已修改的数据,您确定进行此操作么？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        }).then(({ value }) => {
          this.loadingObj.loading = true
          this.saveBtn('flow').then(() => {
            this.definestartUp()
          })
        })
      } else {
        this.loadingObj.loading = false
        this.definestartUp()
      }
    },
    //确定提交审批
    definestartUp() {
      var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/customFlowValidate/' + this.detailInfos.id
      this.$axios.get(url).then((res) => {
        if (res.data.code == 0) {
          var url1 = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/' + this.detailInfos.id;
          this.$axios.get(url1).then((res) => {
            if (res.data.code == 0) {
              this.loadingObj.loading = false
              this.$message.success(res.data.msg)
              this.judgeFlowisEnd()
              this.view(this.detailInfos)
            } else {
              this.loadingObj.loading = false
              this.$message.warning(res.data.msg)
            }
          }).catch((err) => {
          });
        } else {
          this.loadingObj.loading = false
          this.$message.warning(res.data.msg)
        }
      }).catch((err) => {
      });
    },
    //审批前的判断
    approval() {
      if (this.isCanEditDetailInfo) {
        this.$confirm("审批会自动保存已修改的数据,您确定进行此操作么？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        }).then(({ value }) => {
          this.loadingObj.loading = true
          this.saveBtn('flow').then(() => {
            this.defineapproval()
          })
        })
      } else {
        this.loadingObj.loading = true
        this.defineapproval()
      }
    },
    //确认审批
    defineapproval() {
      var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/customFlowValidate/' + this.detailInfos.id
      this.$axios.get(url).then((res) => {
        if (res.data.code == 0) {
          var url1 = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/isEnd/' + this.detailInfos.id;
          this.$axios.get(url1).then((res) => {
            if (res.data.code == 0) {
              this.loadingObj.loading = false
              this.$message.warning(res.data.msg)
            } else {
              //查询当前责任人，对比是不是当前责任人
              this.$axios.get(Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/Executors/' + this.detailInfos.id, {}).then((res) => {
                var result = res.data.data;
                var users = [];
                var usernames = []
                for (let i = 0; i < result.length; i++) {
                  users.push(result[i].nickname);
                  usernames.push(result[i].username);
                }
                this.flowuser = users.join(',');
                this.flowusername = usernames.join(',');
                //判断当前用户是否为当前责任人
                if (this.flowusername.indexOf(this.currentuser.username) != -1) {
                  this.approvalModel();
                } else {
                  this.loadingObj.loading = false
                  this.$message.warning("您不是当前节点审批人")
                }

              }).catch((err) => {
              });
            }
          }).catch((err) => {
          });
        } else {
          this.loadingObj.loading = false
          this.$message.warning(res.data.msg)
        }
      }).catch((err) => {
      });
    },
    //输入审批意见的弹框  -- 查询审批的按钮
    approvalModel() {
      var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/lineBtns/' + this.detailInfos.id
      this.$axios.get(url).then((res) => {
        if (res.data.code == 0) {
          this.approvebtnList = res.data.data
          this.approveForm.opinion = "";
          this.innerVisible = true
          this.loadingObj.loading = false
        } else {
          this.$message.warning(res.data.msg)
          this.loadingObj.loading = false
        }
      }).catch((err) => {
      });
    },
    //同意/驳回审批按钮
    approveBtns(item) {
      this.$refs.approveForm.validate((valid) => {
        if (valid) {
          var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/' + this.detailInfos.id;
          var data = {
            "direction": item.direction,
            "opinion": this.approveForm.opinion,
          }
          this.$axios.post(url, data).then((res) => {
            if (res.data.code == 1) {
              this.innerVisible = false
              this.$message.warning(res.data.msg)
            } else {
              this.$message.success(res.data.msg)
              this.innerVisible = false
              this.judgeFlowisEnd()
              this.view(this.detailInfos)
            }
          }).catch((err) => {
          });
        }
      })
    },
    //主表保存按钮
    saveBtn(str) {
      return new Promise(resolve => {
        this.$refs.form.validate((valid) => {
          this.$store.commit("setistouchvalidateChild", true)
          var validateChildResult = this.validateChildFormResult.every((val) => {
            return val.validateFlag
          })
          if (valid && validateChildResult) {
            this.$store.commit("setistouchvalidateChild", false)
            this.$store.commit("setvalidateChildFormResult", [])
            var saveInfo = {}
            for (let key in this.detailInfos) {
              if (key.indexOf('-') != -1) {   //对  一对一主子表字段的特殊处理
                saveInfo[key.replace('-', '.')] = this.detailInfos[key]
              } else if (key.indexOf('CheckboxModel') != -1) {
                saveInfo[key.substr(0, key.indexOf('CheckboxModel'))] = this.detailInfos[key].join(',')
              } else if (key.indexOf('SelectBox') != -1) {
                saveInfo[key.substr(0, key.indexOf('SelectBox'))] = this.detailInfos[key].join(',')
              } else {
                saveInfo[key] = this.detailInfos[key]
              }
            }
            for (let key in this.$store.state.childrensInfo) {
              if (key.indexOf('Readonly') == -1) {
                saveInfo[key] = this.$store.state.childrensInfo[key]
              }
              //对子表分页缓存数据进行保存
              if (key.indexOf('ChangeData') != -1) {
                var currentChildData = saveInfo[key.substr(0, key.indexOf('ChangeData'))]
                var ids = []
                currentChildData.forEach((item) => {
                  if (!!item.id) {
                    ids.push(item.id)
                  }
                })
                saveInfo[key].forEach((item) => {
                  if (ids.indexOf(item.id) == -1) {
                    currentChildData.push(item)
                  } else {
                    var index = currentChildData.findIndex(item1 => item1.id == item.id)
                    currentChildData[index] = item
                  }
                })
              }
            }
            // 对多级子表的特殊处理
            for (var m = 0; m < this.childTableJson.length; m++) {
              if (this.childTableJson[m].options.hierarchy > 1) {
                delete saveInfo[this.childTableJson[m].options.uniqueIdentification]
              }
            }
            console.log(saveInfo, "保存数据最终结果")
            if (str != 'flow') {
              this.loadingObj.loading = true
            }
            let saveflag = str == 'flow' ? 'flow' : 'save'
            var url = Config.dev_url + "/api-apps/app/" + this.$route.params.app + "/addOrEdit" + '?saveflag=' + saveflag
            this.$axios.post(url, saveInfo).then(res => {
              if (res.data.code == 0) {
                this.$store.commit('setDetailInfo', res.data.data)
                if (str != 'flow') {
                  // this.loadingObj.loading = false
                  this.$message.success(res.data.msg)
                  if (this.currentAppIsHasFlow) {
                    // this.isWhichNode()
                  this.$refs.customizationComponents.flowView(this.loadingObj)
                      this.IsShowApprovalBtn()
                  } else {
                    this.loadingObj.loading = false
                  }
                }
                this.getcreateuserdesc()
                this.getupdateuserdesc()
                this.$store.commit('setDataChangeStatus', 0)
                this.$store.commit('setisSaveAllData', 0)
                resolve()
              } else {
                this.loadingObj.loading = false
                this.$message.warning(res.data.msg)
              }
            }).catch((err) => {
            });
          } else {
            this.loadingObj.loading = false
            this.$message.warning('有必填项字段未填！')
          }
        })
      })
    },
    //主表新增按钮
    addBtn(item) {
      this.pageSign = 'add'
      var obj = {};
      this.initAddDefault(obj)
      //新建时默认给创建人id
      obj.createuser = this.currentuser.id
      this.$store.commit('setisCanEditDetailInfo', true)
      this.isShowEditBtn = false
      this.$store.commit('setcurrentDetailTabsModel', this.currentDetailPageJson.columns[0].label)
      this.listItem = obj
      this.$store.commit('setchildrensInfo', {})
      this.$store.commit('setDetailInfo', obj)
      this.drawer = true;
      this.initDetailInfoScrollTop()
      this.$store.commit('setDataChangeStatus', 1)
      this.$nextTick(() => {
        this.$store.commit('setisrequestChildTableData', true)
      })
      // 新建默认值
      var addurl = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/addDefault'
      this.$axios.get(addurl).then((res) => {
        if (res.data.code == 0) {
          var addDefaultData = res.data.data
          for (let key in addDefaultData) {
            this.$set(this.$store.state.detailInfo, key, addDefaultData[key])
          }
        }
      }).catch((err) => {
      });
      //新建时流程初始化
      this.isApprove = 3
      this.flowHistoryList = []
      this.flowuser = ""
      //处理先进入详情再点击新建表单验证被触发的问题
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
        // this.initDetailDrawer()
      })
    },
    //查看详情
    view(item) {
      this.flowuser = "";
      this.flowHistoryList = [];
      this.flowusername = "";
      this.pageSign = 'view'
      this.$store.commit('setisCanEditDetailInfo', true)
      this.isShowEditBtn = true
      this.$store.commit('setcurrentDetailTabsModel', this.currentDetailPageJson.columns[0].label)
      this.listItem = item
      this.$store.commit('setisrequestChildTableData', false)
      this.$store.commit("setchildrensInfo", {})
      if (!!item.id || !!item.ID) {
        this.loadingObj.loading = true
        var url = Config.dev_url + "/api-apps/app/" + this.$route.params.app + "/" + item.id || !!item.ID
        this.$axios.get(url, {}).then(res => {
          this.initDetailData(res.data)
          this.$store.commit('setDetailInfo', res.data)
          var frameindex = Number(localStorage.getItem("iframeindex"));
          parent.putShareValue(frameindex, res.data);
          this.getcreateuserdesc()
          this.getupdateuserdesc()
          this.drawer = true;
          this.initDetailInfoScrollTop()
          this.loadingObj.loading = false
          this.$nextTick(() => {
            this.$store.commit('setisrequestChildTableData', true)
            // this.initDetailDrawer()
          })
          this.$store.commit('setDataChangeStatus', 0)
          if (this.currentAppIsHasFlow) {
            this.$refs.customizationComponents.flowView(this.loadingObj)
            this.judgeFlowisEnd();
            //进入详情判断是不是当前责任人控制转办按钮显示|隐藏
            this.getViewPople("isShowtransfer")
          } else {
            this.loadingObj.loading = false
          }
        }).catch((err) => {
        });
      }
    },
    //获取创建人描述
    getcreateuserdesc() {
      if (!!this.detailInfos.createuser) {
        var url = Config.dev_url + '/api-user/usersInfo/' + this.detailInfos.createuser
        this.$axios.get(url).then((res) => {
          this.$set(this.detailInfos, 'createuserdesc', res.data.nickname)
        }).catch((err) => {
        });
      }
    },
    //获取修改人描述
    getupdateuserdesc() {
      if (!!this.detailInfos.updateuser) {
        var url = Config.dev_url + '/api-user/usersInfo/' + this.detailInfos.updateuser
        this.$axios.get(url).then((res) => {
          this.$set(this.detailInfos, 'updateuserdesc', res.data.nickname)
        }).catch((err) => {
        });
      }
    },
    judgeFlowisEnd() {
      var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/isEnd/' + this.detailInfos.id;
      this.$axios.get(url, {}).then((res) => {
        if (res.data.code == 0) {
          this.isApprove = 2
          this.$store.commit('setisCanEditDetailInfo', false)
          this.isShowEditBtn = false
        } else {
          this.isWhichNode()
        }
      }).catch((err) => {
      });
    },
    //获取流程地图
    getFlowMap() {
      this.flowMapSrc = false
      this.flowmaploading = true
      var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/isStart/' + this.detailInfos.id;
      this.$axios.get(url, {}).then((res) => {
        if (res.data.code == 1) {
          this.flowmaploading = false
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        } else {
          var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/image/' + this.detailInfos.id;
          this.$axios.get(url, {}).then((res) => {
            this.isShowFlowMap = true;
            this.flowmaploading = false
            var result = res.data.data;
            result = JSON.parse(result).images
            this.flowMapSrc = "data:image/png;base64," + result[0]
          }).catch((err) => {
          });
        }
      }).catch((err) => {
      });
    },
    //获取流程历史
    getflowHistory() {
      this.flowHistoryList = [];
      this.flowloading = true
      var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/isStart/' + this.detailInfos.id;
      this.$axios.get(url, {}).then((res) => {
        if (res.data.code == 1) {
          this.flowloading = false
          this.$message.warning(res.data.msg)
        } else {
          var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/history/' + this.detailInfos.id;
          this.$axios.get(url, {}).then((res) => {
            this.flowloading = false
            this.flowhistorydialog = true
            for (var i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].flag == true) {
                res.data.data[i].flag = "success";
              } else {
                res.data.data[i].flag = "error";
              }
            }
            this.flowHistoryList = res.data.data;
          }).catch((err) => {
          });
        }
      }).catch((err) => {
      });
    },
    //获取当前责任人
    getViewPople(str) {
      this.user = "";
      var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/isEnd/' + this.detailInfos.id;
      this.$axios.get(url, {}).then((res) => {
        if (res.data.code == 0) {
          this.flowuser = "流程已结束，无当前责任人"
        } else {
          var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/Executors/' + this.detailInfos.id;
          this.$axios.get(url, {}).then((res) => {
            var result = res.data.data;
            var users = [];
            var usernames = []
            for (let i = 0; i < result.length; i++) {
              users.push(result[i].nickname);
              usernames.push(result[i].username);
            }
            this.flowuser = users.join(',');
            this.flowusername = usernames.join(',');
            if(str == "isShowtransfer"){
              if (this.flowusername.indexOf(this.currentuser.username) != -1) {
                  this.isShowtransfer = true
              }else{
                  this.isShowtransfer = false
              }
            }else{
              this.flowpeopledialog = true
            }
          }).catch((err) => {
          });
        }
      }).catch((err) => {
      });
    },
    //新建 / 查看详情时所有tab页滚动条归0
    initDetailInfoScrollTop() {
      var arr = document.getElementsByClassName("el-tab-pane")
      for (var i = 0; i < arr.length; i++) { arr[i].scrollTop = 0 }
    },
    //待办跳转 --- 待办查看详情
    todoViewDetail(item) {
      this.bizId = item.bizId
      var data = {
        menucode: item.menucode,
        rolecode: this.currentuser.rolecode
      }
      //待办跳转 -- 请求应用按钮
      if (!!data.menucode && !!data.rolecode) {
        var url = Config.dev_url + '/api-user/permissions/getPermissionByRoleCodeAndSecondMenu'
        this.$axios.get(url, { params: data }).then((res) => {
          this.$store.commit("setButtons", res.data)
        }).catch((err) => {
        });
      }
      //待办跳转 -- 请求页面json
      this.getJson(item)
    },
    //待办跳转 --- 请求当前页面的json
    getJson(item) {
      this.initPage()
      var url = Config.dev_url + "/api-apps/appcfg/pageLayout/" + this.$route.params.app;
      this.$axios.get(url, {}).then(res => {
        this.ishasFlow()
        this.ishasReport()
        if (res.status == 200) {
          if (res.data == null) {
            var jsonDatas = {
              list: [],
              config: {
                labelWidth: 100,
                labelPosition: 'right',
                size: 'small',
                customClass: ''
              }
            }
          } else {
            var jsonDatas = res.data;
          }
          //存储当前应用json
          this.$store.commit('setJsonData', jsonDatas)
          if (!!this.jsonData.list[0].columns[0].list[0]) {
            this.$store.commit('setCurrentMainTableJson', this.jsonData.list[0].columns[0].list[0])
          }
          //详情主信息json
          var detailJosnArr = []
          this.filterJson(jsonDatas.list, detailJosnArr)
          this.$store.commit('setdetailJosnArr', detailJosnArr)
          //详情json
          if (!!jsonDatas.list[0]) {
            var detailPageJson = jsonDatas.list[0]
            detailPageJson.columns = detailPageJson.columns.filter((item) => {
              return item.label != "列表"
            })
            this.$store.commit('setcurrentDetailTabsModel', detailPageJson.columns[0].label)
            this.$store.commit('setCurrentDetailPageJson', detailPageJson)
            this.view({ id: item.bizId })
          }
        } else {
          this.$message.warning(res.statusText)
        }
      }).catch((err) => {
      });
    },
    //待办跳转 --- 应用初始化
    initPage() {
      this.$store.commit('setdetailJosnArr', [])
      this.$store.commit('setcurrentAppIsHasFlow', false)
      this.$store.commit('setcurrentAppIsHasReport', false)
      this.$store.commit('setCurrentMainTableJson', {})
      this.$store.commit('setCurrentDetailPageJson', {})
      this.$store.commit('setcurrentDetailTabsModel', "")
      this.$store.commit('setchildrensInfo', {})
      this.$store.commit('setisrequestChildTableData', false)
      this.$store.commit('setisCanEditDetailInfo', false)
      this.$store.commit('setisCanEditChildInfo', false)
      this.$store.commit('setchildTableJson', [])
    },
    //待办跳转 --- 递归查找主表字段显示形式的json
    filterJson(list, arr) {
      list.forEach((item) => {
        if (item.type == "tabs" || item.type == "grid") {
          item.columns.forEach((itemcolumn) => {
            itemcolumn.list.forEach((itemcolumnlist) => {
              if (itemcolumnlist.type != "tabs" && itemcolumnlist.type != "grid" && itemcolumnlist.type != "table") {
                arr.push(itemcolumnlist)
              } else if (itemcolumnlist.type != "table") {
                itemcolumnlist.columns.forEach((itemcolumnlistcolumn) => {
                  this.filterJson(itemcolumnlistcolumn.list, arr)
                })
              }
            })
          })
        } else if (item.type != "table") {
          arr.push(item)
        }
      })
    },
    //待办跳转 --- 判断当前应用是否有流程
    ishasFlow() {
      var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/flow/isBinding'
      this.$axios.get(url).then((res) => {
        if (res.data.code == 0) {
          this.$store.commit('setcurrentAppIsHasFlow', true)
        } else {
          this.$store.commit('setcurrentAppIsHasFlow', false)
        }
      }).catch((err) => {
      });
    },
    //待办跳转 --- 判断当前应用是否有报表
    ishasReport() {
      var url = Config.dev_url + '/api-apps/app/' + this.$route.params.app + '/reportList'
      this.$axios.get(url).then((res) => {
        if (res.data.code == 0) {
          this.$store.commit('setcurrentAppIsHasReport', true)
        } else {
          this.$store.commit('setcurrentAppIsHasReport', false)
        }
      }).catch((err) => {
      });
    },
  },
  computed: {
    //主表信息
    detailInfos() {
      return this.$store.state.detailInfo
    },
    //当前登录人信息
    currentuser() {
      return this.$store.state.currentuser
    },
    //当前左侧菜单选中的信息
    currentSelectMenuData() {
      return this.$store.state.currentSelectMenuData
    },
    //当前主表json信息
    currentMainTableJson() {
      return this.$store.state.currentMainTableJson
    },
    //当前应用的json信息
    jsonData() {
      return this.$store.state.jsonData
    },
    //详情显示的按钮
    detailButtons() {
      return this.$store.state.buttons.filter((item) => {
        if (this.currentAppIsHasReport) {
          return item.isforothertab == '1' && item.eventmethod != 'flowBtn'
        } else {
          return item.isforothertab == '1' && item.eventmethod != 'flowBtn' && item.eventmethod != 'reportBtn'
        }
      })
    },
    //详情页是否有流程按钮
    isHasFlowBtn() {
      return this.$store.state.buttons.some((item) => {
        return item.eventmethod == 'flowBtn'
      })
    },
    //当前应用是否有流程
    currentAppIsHasFlow() {
      return this.$store.state.currentAppIsHasFlow
    },
    //当前应用是否有报表
    currentAppIsHasReport() {
      return this.$store.state.currentAppIsHasReport
    },
    //当前应用详情页json
    currentDetailPageJson() {
      return this.$store.state.currentDetailPageJson
    },
    //详情页主表json
    detailJosnArr() {
      return this.$store.state.detailJosnArr
    },
    //左侧菜单以及应用详情抽屉显示状态
    menuAndDrawer() {
      return this.$store.state.menuAndDrawer
    },
    //是否可编辑主表信息
    isCanEditDetailInfo() {
      return true
    },
    //当前应用的所有子表json信息
    childTableJson() {
      return this.$store.state.childTableJson
    },
    //是否保存所有数据
    isSaveAllData() {
      return this.$store.state.isSaveAllData
    }
  },
  watch: {
    //左侧菜单点击关闭抽屉
    menuAndDrawer(val) {
      this.drawer = val
    },
    //监听是否需要刷新列表数据
    isSaveAllData(val) {
      if (val) {
        this.saveBtn()
      }
    }
  },
  mounted() {
    // this.initDetailInfoScrollTop() //初始化详情tab高度置0
    // this.initDetailDrawer()  //初始化计算详情抽屉高度
    // //窗口大小发生变化时，重新计算详情抽屉高度
    // window.onresize = ()=> {
    //     if(!this.ischangeView){
    //         if(document.getElementsByClassName("detailDrawer").length > 0){
    //             this.initDetailDrawer()
    //         }
    //     }
    // }
  },
}
</script>

<style>
</style>
